export default "__VITE_ASSET__fM7Ip2cv__"